export default __webpack_public_path__ + "static/media/typeScript.7fd39274.png";